import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/realtimeChatRecords/load',
    method: 'get',
    params,
  })
}
